import React, { useState } from 'react';

const Action = () => {
    const [data] = useState({
        title: "Let's Create Something New",
        desc: 'Or Make Something Old Shine Again',
    });

    const mailchimpUrl = "https://us5.list-manage.com/contact-form?u=681f314a9456ece504da69f44&form_id=53b5797331d6c57bbcaf4cb696ce424a";

    return (
        <section className="tf-section action">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="action__body" data-aos="fade-up">
                            <div className="block-text">
                                <h3 className="mb-13">{data.title}</h3>
                                <p className="fs-21 mb-7">{data.desc}</p>
                            </div>
                            <a 
                                href={mailchimpUrl} 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="btn-action style-2"
                            >
                                Get in touch
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Action;
